// extracted by mini-css-extract-plugin
export default {"dynamicLabel":"dynamicLabel--dab96a4dbb73fea270df"};